import { useTranslation } from "react-i18next";
import { useStatusesStore } from "../../../../../../store/admin/statusesStore";
import type { ThemeClasses } from "../types";
import Select from "react-select";
import { getCustomSelectStyles, FilterPopover } from "../../../../shared";
import { getStatusOptionsForEntity } from "../../../../../../utils/getStatusEntity";

const categoryFilterOptions = [
  { value: "residence", label: "Residencia" },
  { value: "client", label: "Cliente" },
  { value: "work", label: "Trabajo" },
  { value: "warehouse", label: "Almacén" },
  { value: "office", label: "Oficina" },
  { value: "gas_station", label: "Gasolinera" },
  { value: "other", label: "Otro" },
];

interface PointOfInterestFiltersProps {
  status_id: string;
  category_id: string;
  searchQuery: string;
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  onStatusChange: (value: string | null) => void;
  onCategoryChange: (value: string | null) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function PointOfInterestFilters({
  status_id,
  category_id,
  searchQuery,
  isDarkMode,
  themeClasses,
  onStatusChange,
  onCategoryChange,
  onSearchChange,
}: PointOfInterestFiltersProps) {
  const { t } = useTranslation("adminSections");

  const statuses = useStatusesStore((state) => state.statuses);
  const statusOptionsSelect = getStatusOptionsForEntity(statuses, "pointsOfInterest", t);

  return (
    <div className="flex items-center gap-2 flex-1 min-w-0">
      {/* Búsqueda */}
      <div className="relative flex-1 min-w-0 sm:flex-none sm:w-72">
        <i
          className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 ${themeClasses.textSecondary}`}
        ></i>
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder={t("pointsOfInterest.searchPlaceholder")}
          className={`w-full h-9 pl-10 pr-4 py-2 ${isDarkMode ? "bg-dark-card" : "bg-gray-50"
            } border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} text-sm focus:outline-none focus:ring-2 focus:ring-primary-500`}
        />
      </div>
      <FilterPopover
        isDarkMode={isDarkMode}
        activeCount={(category_id ? 1 : 0) + (status_id ? 1 : 0)}
        onClear={() => {
          onCategoryChange(null);
          onStatusChange(null);
        }}
      >
        {/* Tipo de punto de interés */}
        <Select
          options={categoryFilterOptions}
          styles={getCustomSelectStyles(isDarkMode)}
          placeholder={t("pointsOfInterest.filters.selectCategory")}
          value={categoryFilterOptions.find((opt) => opt.value === category_id) || null}
          onChange={(option: any) => onCategoryChange(option?.value || null)}
          isSearchable
          isClearable
          noOptionsMessage={() => t("pointsOfInterest.filters.noCategoriesAvailable")}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
        {/* Estado */}
        <Select
          options={statusOptionsSelect}
          styles={getCustomSelectStyles(isDarkMode)}
          placeholder={t("pointsOfInterest.filters.selectStatus")}
          value={statusOptionsSelect.find((opt) => opt.value === status_id) || null}
          onChange={(option: any) => onStatusChange(option?.value || null)}
          isSearchable
          isClearable
          noOptionsMessage={() => t("pointsOfInterest.filters.noStatusesAvailable")}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FilterPopover>
    </div>
  );
}
